import { Box, Divider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ProductSwiper from "containers/custom/productSwiper";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import { Container } from "..";

export const Image = styled("img")(({ theme }) => ({
  width: "100%",
  border: "1px solid",
  boxSizing: "border-box",
  borderColor: theme.palette.grey[300],
}));

export default function RelatedTemplate(): React.ReactElement {
  const { recommends } = useTemplate();

  return (
    <Box>
      <Divider sx={{ my: 2 }}>
        <Typography variant="h4">You might also like</Typography>
      </Divider>
      <Container>
        <ProductSwiper templates={recommends} />
      </Container>
    </Box>
  );
}
